<div class="waveform-container" [style.background-color]="backgroundColor">
	<button mat-icon-button (click)="togglePlay()">
		<mat-icon class="play-icon" [inline]="true">{{ wavesurfer?.isPlaying() ? 'pause_circle' : 'play_circle' }}</mat-icon>
	</button>
	<div #waveform class="waveform"></div>
	<div class="flex-column center-container" style="width: unset;" *ngIf="showClearButton">
		<button mat-icon-button color="warn" (click)="onClearPressed()">
			<mat-icon>clear</mat-icon>
		</button>
	</div>
</div>
